// t566 (30-oct-2026) · LOS PERFILES QUE SE PUEDEN ELEGIR EN UN GRUPO ABIERTO DEL CHAT DEL EQUIPO
//
// El dueño: «los roles personalizados deben salir también en los grupos de chat de equipo». Hasta hoy las dos pantallas
// del chat (pages/ChatEquipo y components/ChatWidget) tenían escritos a mano seis roles de serie, y un rol propio de la
// clínica («Coordinación»…) no se podía elegir. Ahora la lista la da el servidor (GET /api/chat/perfiles): los de fábrica
// —también Doctor/a e Higienista— y los roles propios de ESTA clínica, con el nombre que les puso. Son los mismos con los
// que el servidor comprueba al guardar el grupo (backend/routes/chat.js · perfilesDelChat): lo que se ofrece y lo que se
// acepta no se pueden contradecir. Cada pantalla los pide con su `useQuery` (PETICION_PERFILES) y los pinta con esto.
//
// Mientras la respuesta no llega (o si falla), los de fábrica: el grupo se puede seguir creando como hasta hoy.
import { nombreRol } from './nombreRol'
import { marca } from './i18n.js'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const PERFILES_DE_FABRICA = [
  ['admin', marca('utils.perfilesChat.administracion', 'Administración')], ['recepcion', marca('utils.perfilesChat.recepcion', 'Recepción')], ['doctor', 'Doctor/a'], ['higienista', marca('utils.perfilesChat.higienista', 'Higienista')],
  ['colaborador', marca('utils.perfilesChat.colaborador', 'Colaborador')], ['auxiliar', marca('utils.perfilesChat.auxiliar', 'Auxiliar')], ['almacen', marca('utils.perfilesChat.almacen', 'Almacén')], ['limpieza', marca('utils.perfilesChat.limpieza', 'Limpieza')],
]

export const RUTA_PERFILES = '/chat/perfiles'

// Lo que contesta el servidor ({ perfiles: [{ clave, nombre, propio }] }) → [[clave, nombre]]. Sin respuesta, los de fábrica.
export function opcionesDePerfiles(perfiles) {
  if (!Array.isArray(perfiles) || !perfiles.length) return PERFILES_DE_FABRICA
  const out = perfiles.filter((p) => p && p.clave).map((p) => [String(p.clave), String(p.nombre || nombreRol(p.clave))])
  return out.length ? out : PERFILES_DE_FABRICA
}

// Los perfiles que ya tiene un grupo y no salen en la lista (un rol propio que la clínica borró después): se enseñan
// también, marcados, para que se puedan quitar.
export function conLosDelGrupo(opciones, elegidos) {
  const hay = new Set(opciones.map(([v]) => v))
  const extra = (Array.isArray(elegidos) ? elegidos : []).filter((r) => r && !hay.has(r)).map((r) => [r, nombreRol(r)])
  return extra.length ? [...opciones, ...extra] : opciones
}
